import { createBrowserRouter } from "react-router-dom";
import LoginLayout from "./layouts/LoginLayout";
import LoginPage from "./pages/Login/LoginPage";
import MainLayout from "./layouts/MainLayout";
import ForgotPasswordPage from "./pages/Login/ForgotPasswordPage";
import ResetPasswordPage from "./pages/Login/ResetPasswordPage";
import ProtectedRoute from "./components/ProtectedRoute";

export const AppRoutes = createBrowserRouter([
  {
    // Everything below requires an authenticated session.
    element: <ProtectedRoute />,
    children: [
      {
        // MainLayout owns all authenticated routes; the tab workspace resolves
        // the actual page for the current URL (see tabs/tabRoutes.tsx).
        path: "*",
        element: <MainLayout />,
      },
    ],
  },
  {
    element: <LoginLayout />,
    children: [
      {
        path: "/forgot-password",
        element: <ForgotPasswordPage />,
      },
      {
        path: "/login",
        element: <LoginPage />,
      },
      {
        path: "/reset-password/:token",
        element: <ResetPasswordPage />,
      },
    ],
  },
]);
